import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Grid from '@material-ui/core/Grid';
import { PageHero, Section, LoadingState, EmptyState } from '../Common/PageLayout';
import { listConsultations } from './consultationApi';
import ConsultationCard from './ConsultationCard';

/** Laws and proposals the Ministry has opened for public comment. */
export default function ConsultationList() {
    const [state, setState] = useState({ items: [], loading: true, error: false });

    useEffect(() => {
        let active = true;
        listConsultations()
            .then((items) => active && setState({ items, loading: false, error: false }))
            .catch(() => active && setState({ items: [], loading: false, error: true }));
        return () => {
            active = false;
        };
    }, []);

    return (
        <>
            <Helmet defer={false}>
                <title>Public consultations | Ministry of Finance, Timor-Leste</title>
                <meta
                    name="description"
                    content="Read draft laws and proposals from the Ministry of Finance and share your comments."
                />
            </Helmet>

            <PageHero
                eyebrow="Have your say"
                title="Public consultations"
                description="Read draft laws and proposals from the Ministry of Finance and share your comments before decisions are made."
                breadcrumbs={[{ label: 'Public consultations' }]}
            />

            <Section>
                {state.loading && <LoadingState label="Loading consultations" />}
                {!state.loading && state.error && (
                    <EmptyState
                        title="Consultations could not be loaded"
                        description="Please check your connection and try again later."
                    />
                )}
                {!state.loading && !state.error && state.items.length === 0 && (
                    <EmptyState
                        title="No open consultations"
                        description="There are no laws or proposals open for public comment at the moment. Please check back later."
                    />
                )}
                {!state.loading && !state.error && state.items.length > 0 && (
                    <Grid container spacing={4}>
                        {/* The newest consultation is featured across the full width. */}
                        {state.items.map((post, index) => (
                            <Grid item xs={12} sm={index === 0 ? 12 : 6} md={index === 0 ? 12 : 4} key={post.id}>
                                <ConsultationCard post={post} featured={index === 0} />
                            </Grid>
                        ))}
                    </Grid>
                )}
            </Section>
        </>
    );
}
